import { propOr } from 'ramda';

// eslint-disable-next-line import/prefer-default-export
export const getTaskProgress = (data) => {
  if (data.spent_time && !data.estimated_time) return 100;
  return Math.floor((propOr(0, 'spent_time', data) * 100) / propOr(1, 'estimated_time', data));
};
